module.exports = __webpack_public_path__ + "img/bg82.8474dc7e.png";